<style lang="less" scoped>
.swiperCard{position: relative;width:1300px;overflow:hidden;}
ul{list-style: none;display: flex;margin: 50px 0px;}
li{width: 240px;height:330px;overflow: hidden;margin: 0px 10px;padding: 0px;background: white;border: 3px solid rgb(226, 219, 219);cursor: pointer;transition: transform .5s;}
.pic{width: 240px;height:150px;}
.title{font-size: 16px;font-weight: 600;text-align: left;margin: 10px 10px;}
.introduce{font-size: 16px;margin: 0px 10px;text-align: left;display:-webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;text-indent:2em}
li:hover {transform: scale(1.2,1.2);box-shadow: 0px 0px 3px 5px rgb(212, 211, 211);}
</style>

<!-- 何宽 2021.9.10
     该组件使用场景：自动轮播一组卡片，鼠标移入卡片放大，点击图片、标题或内容，将整个对象传递给父组件 -->
<template>
  <div class="swiperCard">
    <ul>
      <li class="DataList_left" v-for="(item,index) in swiperCardList" :key="index" @click="clickSwiperCard(item)">
        <img class="pic" :src="item.thumb" />
        <p class="title">{{ item.title }}</p>
        <p class="introduce">{{ item.introduce }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  props: ['swiperCardList'],
  components:
  {
    vueSeamlessScroll
  },
  data()
  {
    return {
    }
  },
  // 点击图片或图片标题，将该图片对象传递给父组件
  methods: {
    clickSwiperCard(item)
    {
      this.$emit('clickSwiperCard', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SwiperCard.vue